<script>
  import { getImageNaturalSize, scaleNumbers } from "../javascripts/utils"
  export let imageURL
  export let imageViewer
  let palette = []

  getImageNaturalSize(imageURL).then(image => {
    imageViewer.setAttribute(
      "data-image-size",
      `${image.width} x ${image.height}`
    )
    import(/* webpackChunkName: "ColorThief" */ "colorthief").then(
      async ({ default: ColorThief }) => {
        const ct = new ColorThief()
        const imgEl = image.element
        const colorPallette = await ct.getPalette(imgEl, 4)
        const [primaryColor = false] = colorPallette
        palette = colorPallette.filter(
          (color = String(color), idx) =>
            idx === 0 || (idx > 0 && String(color) !== String(palette[idx - 1]))
        )
        if (primaryColor) {
          const colorRange = { max: 255, low: 0 }
          const opacityRange = { max: 1, min: 0 }
          let averageRGB = primaryColor.reduce((a, b) => a + b) / 3
          let RGBScale = scaleNumbers(
            averageRGB,
            colorRange,
            opacityRange
          ).toFixed(3)
          imageViewer.style.background =
            "rgba(127, 127, 127, " + (1 - RGBScale) + ")"
        }
      }
    )
  })

  const componentToHex = color => {
    const hex = color.toString(16)
    return hex.length == 1 ? "0" + hex : hex
  }

  function rgba2hex(r, g, b) {
    return componentToHex(r) + componentToHex(g) + componentToHex(b)
  }
</script>

<style>
  .image-viewer-color-pallet > span {
    background: rgb(255, 255, 255);
  }
</style>

<img src={imageURL} alt="currentImage" />
<div class="image-viewer-color-pallet">
  {#each palette as color}
    <span
      class="image-viewer-color-box"
      style="background:rgb({String(color)})">
      <span>{String(rgba2hex(...color))} rgb({String(color)})</span>
    </span>
  {:else}
    <span />
  {/each}
</div>
